// src/components/products/constants.js

// Constants for dropdown options
export const METAL_TYPES = [
  'Yellow Gold',
  'White Gold',
  'Rose Gold',
  'Platinum',
  'Silver',
  'Palladium',
  'Two-tone'
];

export const GEMSTONE_TYPES = [
  'Diamond',
  'Sapphire',
  'Ruby',
  'Emerald',
  'Tanzanite',
  'Aquamarine',
  'Morganite',
  'Topaz',
  'Garnet',
  'Tourmaline',
  'Spinel',
  'Amethyst',
  'Opal',
  'Pearl',
  'Mixed Gemstones',
  'Other Gemstone',
  'No Gemstone'
];

export const GEMSTONE_COLORS = [
  'Clear/White',
  'Blue',
  'Green',
  'Red',
  'Pink',
  'Purple',
  'Yellow',
  'Orange',
  'Black',
  'Brown',
  'Grey',
  'Multi-coloured'
];

export const SETTING_TYPES = [
  'Claw/Prong',
  'Bezel',
  'Channel',
  'Pavé',
  'Halo',
  'Tension',
  'Bar',
  'Flush',
  'Invisible',
  'Cluster',
  'Half bezel'
];

// Mock data for demonstration
export const mockProducts = [
  {
    id: '1',
    images: ['https://via.placeholder.com/150'],
    name: 'Eternal Elegance Solitaire',
    price: 2500,
    metalType: 'Platinum',
    gemstoneType: 'Diamond',
    gemstoneColor: 'Clear/White',
    settingType: 'Claw/Prong',
    description: 'A timeless classic solitaire ring.',
    status: 'live',
    createdAt: '2024-01-15'
  },
  {
    id: '2',
    images: ['https://via.placeholder.com/150'],
    name: 'Vintage Rose Garden',
    price: 1800,
    metalType: 'Rose Gold | 14ct',
    gemstoneType: 'Ruby',
    gemstoneColor: 'Red',
    settingType: 'Halo',
    description: 'Vintage-inspired halo setting.',
    status: 'draft',
    createdAt: '2024-01-10'
  }
];